"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TypedExecutionResult {
    constructor(autoResult = false) {
        this._result = false;
        this.data = {};
        this.messages = [];
        this.autoResult = autoResult;
    }
    set result(x) {
        if (!this.autoResult)
            this._result = x;
    }
    get result() {
        if (this.autoResult)
            return !this.messages.hasRows();
        else
            return this._result;
    }
    hasErrors() { return this.errors.length > 0; }
    hasWarnings() { return this.warnings.length > 0; }
    get errors() { return this.messages.filter(x => x.type === 'error'); }
    get warnings() { return this.messages.filter(x => x.type === 'warning'); }
    get errorList() {
        return this.errors?.map(error => error.message);
    }
    addErrors(errors) { this.messages.push(...errors); }
    addError(message, code, field) { this.messages.push({ field: field, message: message, code: code, type: 'error' }); }
    addWarning(message, code, field) { this.messages.push({ field: field, message: message, code: code, type: 'warning' }); }
    copy(source) {
        if (source) {
            if (source.messages)
                this.messages.push(...source.messages);
            else if (source.errors)
                this.messages.push(...source.errors);
            else if (source.result === false) {
                this.addError('Command error', 'command-error');
            }
        }
    }
    toObject() {
        const resolve = (obj) => {
            // if ( typeof obj === 'object' )
            // {
            //     if ( typeof obj?.toObject === 'function' )
            //         obj = obj.toObject();
            // }
            // for ( let ob of Object.keys( obj ) )
            // {
            //     if ( typeof obj[ob] === 'object' )
            //     {
            //         if ( typeof obj[ob]?.toObject === 'function' )
            //             obj[ob] = obj[ob].toObject();
            //         else
            //             resolve( obj[ob] );
            //     }
            // }
            return obj;
        };
        let primary_error = null;
        if (this.hasErrors())
            primary_error = this.errors[0];
        return {
            result: this.result,
            //primary_error: primary_error ? primary_error : undefined,
            errors: this.errors,
            warnings: this.warnings,
            data: this.data ? resolve(this.data) : undefined,
        };
    }
}
exports.default = TypedExecutionResult;
